import React from 'react'
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native'
import { IconTrashBin, CreditCardIcon } from '../../../../assets/icons'
import { IPaymentMethodData } from '../flows/PayAsGuestFlow/types'

export const PaymentMethodDetails: React.FC<{
  paymentMethod: IPaymentMethodData
  onRemove: () => void
}> = ({ paymentMethod, onRemove }) => {
  const lastThreeDigits = paymentMethod.card.last4?.slice(-3) ?? '***'

  return (
    <View style={styles.paymentMethodContainer}>
      {/* Top Section */}
      <View style={styles.paymentMethodTopContainer}>
        <View style={styles.cardIconWrapper}>
          <CreditCardIcon />
        </View>

        {/* Card Details */}
        <View style={styles.paymentMethodDetailsContainer}>
          <Text style={styles.paymentMethodType}>
            {`${
              (paymentMethod.card?.type ?? '') + ' Card'
            } ... ${lastThreeDigits}`}
          </Text>
          <Text style={styles.paymentMethodNetwork}>
            {paymentMethod.card?.bankName ?? paymentMethod.card?.network ?? ''}
          </Text>
          <Text style={styles.paymentMethodOwner}>
            {paymentMethod.bankAccount.accountholderName}
          </Text>
        </View>

        {/* Trash Bin */}
        <TouchableOpacity onPress={onRemove}>
          <View style={styles.trashIconWrapper}>
            <IconTrashBin />
          </View>
        </TouchableOpacity>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  paymentMethodContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: 16,
    backgroundColor: '#F4F9FD',
    borderRadius: 12,
  },
  paymentMethodTopContainer: {
    flexDirection: 'row',
    flex: 1,
  },
  cardIconWrapper: {
    marginRight: 15,
    justifyContent: 'flex-start',
  },
  paymentMethodDetailsContainer: {
    flex: 1,
    justifyContent: 'flex-start',
  },
  paymentMethodType: {
    fontSize: 14,
    fontWeight: '700',
    lineHeight: 20,
    color: '#001929',
    fontFamily: 'Inter',
    marginBottom: 4,
  },
  paymentMethodNetwork: {
    fontSize: 12,
    lineHeight: 20,
    fontWeight: '500',
    color: '#001929',
    fontFamily: 'Inter',
    marginBottom: 8,
  },
  paymentMethodOwner: {
    fontSize: 14,
    color: '#001929',
    lineHeight: 20,
    fontWeight: '700',
    fontFamily: 'Inter',
  },
  trashIconWrapper: {
    marginLeft: 10,
    justifyContent: 'flex-start',
  },
})
